
import React, { useEffect, useState } from 'react';
import { MenuIcon } from '@/templates/Showroom/utils/icons';

interface MenuProps {
  onClick?: () => void;
  className?: string;
  isOpen?: boolean;
}

const Menu: React.FC<MenuProps> = ({ onClick, className, isOpen }) => {
  const [isMobile, setIsMobile] = useState(false);

  // Check for mobile screen size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Get responsive sizes
  const getButtonSize = () => {
    if (isMobile) return { width: 36, height: 36, padding: 5 };
    return { width: 42, height: 42, padding: 6 };
  };

  const getIconSize = () => {
    if (isMobile) return { width: 26, height: 20 };
    return { width: 32, height: 24 };
  };

  const getPosition = () => {
    if (isMobile) return 'top-[20px] left-[20px]';
    return 'top-[25px] left-[25px]';
  };

  if (isOpen) return null;

  const buttonSize = getButtonSize();
  const iconSize = getIconSize();
  return (
    <button
      className={`
        fixed ${getPosition()} z-[20000]
        bg-white rounded-full border-none
        flex justify-center items-center
        cursor-pointer transition-all duration-300
        backdrop-blur-[100px]
        shadow-[0_4px_16px_rgba(0,0,0,0.2),inset_-1px_1px_3px_rgba(255,255,255,0.8),inset_0px_4px_10px_3px_rgba(255,255,255,0.2)]
        hover:scale-105 active:scale-95
        ${className || ''}
      `}
      style={{
        width: `${buttonSize.width}px`,
        height: `${buttonSize.height}px`,
        padding: `${buttonSize.padding}px`
      }}
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      aria-label="Open menu"
      type="button"
    >
      <MenuIcon 
        width={iconSize.width} 
        height={iconSize.height} 
        stroke="#656565" 
        strokeWidth={isMobile ? 2.5 : 3} 
      />
    </button>
  );
};

export default Menu;
